<template>
	<div>
		<v-card-title>
			<h2 class="ml-1">Podsumowanie konkursu</h2>
		</v-card-title>
		<v-card-text>
			<contest-summary-data-view/>
			<contest-summary-users-view/>
			<contest-summary-offers-view/>
			<contest-summary-projects-view/>
			<contest-summary-experts-view/>
			<contest-summary-agency-evaluation-authors/>
		</v-card-text>
	</div>
</template>

<script>
	import ContestSummaryDataView from "./components/ContestSummaryDataView";
	import ContestSummaryUsersView from "./components/ContestSummaryUsersView";
	import ContestSummaryOffersView from "./components/ContestSummaryOffersView";
	import ContestSummaryProjectsView from "./components/ContestSummaryProjectsView";
	import ContestSummaryExpertsView from "./components/ContestSummaryExpertsView";
	import ContestSummaryAgencyEvaluationAuthors from "./components/ContestSummaryAgencyEvaluationAuthors";

	export default {
		name: "ContestSummaryView",
		components: {
			ContestSummaryAgencyEvaluationAuthors,
			ContestSummaryExpertsView,
			ContestSummaryProjectsView,
			ContestSummaryOffersView, ContestSummaryUsersView, ContestSummaryDataView
		}
	};
</script>

<style scoped>

</style>
